import { PrimaryDetailsPanelContent, PrimaryDetailsPanelHeading, PrimaryDetailsPanelWrapper } from './styles';
import { ReactNode } from 'react';

type PrimaryDetailsPanelType = {
  children: ReactNode;
  headerSlot?: ReactNode;
  variant?: string;
  width?: string;
};

export const PrimaryDetailsPanel = ({ headerSlot, variant, width, children }: PrimaryDetailsPanelType) => {
  return (
    <PrimaryDetailsPanelWrapper backgroundColor={variant}>
      <PrimaryDetailsPanelHeading>{headerSlot}</PrimaryDetailsPanelHeading>
      <PrimaryDetailsPanelContent width={width}>{children}</PrimaryDetailsPanelContent>
    </PrimaryDetailsPanelWrapper>
  );
};
